import type { DealHealthState } from "@/types/v2/deal"

// Next-step health pictograms (CON-218): red dashed circle
// for "No next step", clock for "Overdue Nd", calendar for
// the scheduled "Kind · date". Inline SVGs follow the
// SparkleMark approach; they inherit the state colour via
// `currentColor`. Lives in its own module so the
// NextStepsSection (drawer / show pages) can reuse the
// dashed-circle marker without importing the kanban card
// (and its dnd-kit dependency).
export function HealthGlyph({
  state,
  size = 11,
}: {
  state: DealHealthState
  size?: number
}) {
  if (state === "none") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        style={{ flexShrink: 0 }}
        aria-hidden="true"
      >
        <circle
          cx="8"
          cy="8"
          r="5.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeDasharray="2.6 2.6"
        />
      </svg>
    )
  }
  if (state === "overdue") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        style={{ flexShrink: 0 }}
        aria-hidden="true"
      >
        <circle
          cx="8"
          cy="8"
          r="5.5"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M8 5V8L10 9.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      style={{ flexShrink: 0 }}
      aria-hidden="true"
    >
      <rect
        x="2.5"
        y="3.5"
        width="11"
        height="10"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M2.5 6.5H13.5M6 2V5M10 2V5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
